import axios from 'axios';

axios.defaults.withCredentials = +process.env.REACT_APP_LOCAL !== 1;

export const apiGetTokenId = async (network = 'ETH') => {
    try {
        const { data } = await axios.get(`${process.env.REACT_APP_BASE_API}/voucher/last`, {
            params: {network: 'ETH'}
        })
        if(data.status) {
            return data.tokenId;
        } else {
            return null;
        }
    } catch (error) {
        return null;
    }
}

export async function uploadAttachments(fileInput: FormData) {
    try {
        const { data } = await axios.post(`${process.env.REACT_APP_BASE_API}/voucher/upload`, fileInput)

        if (data.status){
            return data.attachments
        }
    } catch (error) {
        return null    
    }
}

export async function downloadFile (key: string) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`)
    const response = await fetch(`${process.env.REACT_APP_BASE_API}/voucher/download?key=${key}`, {
        method: 'GET',
        headers
    })
    let header_content = response.headers.get('content-disposition');
    let file = header_content.split('=')[1];
    file = file.substring(1, file.length - 1);

    response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = file;
        a.click();
    });
}

export async function downloadCoA(voucherId: string) {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${localStorage.getItem('accessToken')}`)
    const response = await fetch(`${process.env.REACT_APP_BASE_API}/voucher/${voucherId}/download-coa`, {
        method: 'GET',
        headers
    })
    let header_content = response.headers.get('content-disposition');
    let file = header_content.split('=')[1];
    file = file.substring(1, file.length - 1);

    response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = file;
        a.click();
    });
}


function download(response) {
    let header_content = response.headers.get('content-disposition');
    let file = header_content.split('=')[1];
    file = file.substring(1, file.length - 1);
    // let extension = file.split('.')[1].toLowerCase();
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    // var newBlob = new Blob([response.body], { type: this.createFileType(extension) })
    const newBlob = new Blob([response.body], { type: response.body.type})

    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    const nav = (window.navigator as any);
    if (nav && nav.msSaveOrOpenBlob) {
      nav.msSaveOrOpenBlob(newBlob);
      return;
    }

    // For other browsers: 
    // Create a link pointing to the ObjectURL containing the blob.
    const data = window.URL.createObjectURL(newBlob);
    var link = document.createElement('a');
    link.href = data;
    link.download = file;
    link.click();
    setTimeout(() => {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(data);
    }, 400)
  }